var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-copy-button",on:{"click":_vm.copyText}},[(!_vm.copyValueSuccess)?_c('ui-icon',{attrs:{"size":_vm.iconSize,"type":_vm.iconType,"name":"uiCopy"}}):_c('ui-icon',{attrs:{"size":_vm.iconSize,"type":"success","name":"uiCheck"}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }